import FileUploader from "../lib/file-uploader";

window.FileUploader = FileUploader;